import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND } from "../../data";
import { scrollToId } from "./primitives";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-brand-black pt-20 md:pt-28 px-6 md:px-12 lg:px-16 overflow-hidden">
    <a href={BRAND.phoneHref} data-testid="footer-cta" className="block group">
      <span className="font-mono-p text-xs uppercase tracking-[0.28em] text-brand-red">Ready to break ground?</span>
      <h2 className="mt-4 font-anton uppercase tracking-tighter leading-[0.82] text-[13vw] md:text-[10vw] group-hover:text-brand-red transition-colors duration-500">
        Call {BRAND.phone}
      </h2>
    </a>

    <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-brand-concrete pt-12">
      <div>
        <div className="flex items-center gap-3">
          <img src={BRAND.logo} alt={BRAND.full} className="h-16 w-auto object-contain" />
        </div>
        <p className="mt-4 font-ibm text-sm text-white/50 max-w-xs">
          M Construction LLC provides professional site development services throughout Southwest Florida.
          We specialize in land clearing, grading, house pads, culvert installation, septic preparation,
          and complete dirt work. Our commitment to quality, reliability, and attention to detail ensures
          every project is completed right the first time.
        </p>
        <div className="mt-5 flex gap-2">
          {BRAND.descriptors.map((d) => (
            <span key={d} className="font-mono-p text-[10px] uppercase tracking-[0.2em] border border-brand-concrete px-3 py-1 text-white/60">{d}</span>
          ))}
        </div>
      </div>

      <div className="space-y-3">
        <span className="font-mono-p text-xs uppercase tracking-[0.2em] text-white/40">Contact</span>
        <a href={BRAND.phoneHref} className="flex items-center gap-3 text-white/80 hover:text-brand-red transition-colors"><Phone className="w-4 h-4 text-brand-red" /> {BRAND.phone}</a>
        <a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 text-white/80 hover:text-brand-red transition-colors break-all"><Mail className="w-4 h-4 text-brand-red" /> {BRAND.email}</a>
        <p className="flex items-center gap-3 text-white/80"><MapPin className="w-4 h-4 text-brand-red" /> {BRAND.area}</p>
      </div>

      <div className="space-y-3">
        <span className="font-mono-p text-xs uppercase tracking-[0.2em] text-white/40">Navigate</span>
        {[["Services", "services"], ["Why Us", "why"], ["Work", "work"], ["Get a Quote", "contact"]].map(([l, id]) => (
          <button key={id} onClick={() => scrollToId(id)} className="block text-white/80 hover:text-brand-red transition-colors font-ibm text-sm">
            {l}
          </button>
        ))}
      </div>
    </div>

    <div className="mt-12 py-8 border-t border-brand-concrete flex flex-col md:flex-row justify-between gap-3 text-white/40 font-mono-p text-xs uppercase tracking-[0.15em]">
      <div className="flex flex-col gap-2">
        <span>© {new Date().getFullYear()} Marquez Construction Services LLC</span>
        <span data-testid="footer-dev-credit" className="text-[10px] normal-case tracking-[0.12em] text-white/30">
          Website created by{" "}
          <a
            href="https://jkmediacompany.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-dev-credit-link"
            className="uppercase text-white/50 hover:text-brand-red hover:underline underline-offset-4 transition-colors duration-300"
          >
            JK Digital Media Solutions, LLC
          </a>
        </span>
      </div>
      <span>Built on Experience. Driven by Quality.</span>
    </div>
  </footer>
);
